import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AddressService } from 'src/app/shared/services/address/address.service';

@Component({
    selector: 'app-address',
    templateUrl: './address.component.html',
    styleUrl: './address.component.scss',
    standalone: false
})
export class AddressComponent implements OnInit {

    @Input() fromParent;

    isConfirm: boolean;
    isNotFound: boolean;
    choice: string = "suggest";

    constructor(
        private activeModal: NgbActiveModal,
        private addressService: AddressService) {

    }

    ngOnInit() {
        this.isConfirm = this.fromParent.isConfirm;
        this.isNotFound = this.fromParent.isNotFound;
    }

    suggestAddress() {
        if (this.fromParent && this.fromParent.suggest) {
            return this.addressService.format(this.fromParent.suggest);
        }

        return "";
    }

    enterAddress() {
        if (this.fromParent && this.fromParent.enter) {
            return this.addressService.format(this.fromParent.enter);
        }

        return "";
    }

    editAddress() {
        this.activeModal.dismiss();
    }

    continue() {
        if (this.choice === "suggest") {
            this.activeModal.close(this.fromParent.suggest);
        }
        else {
            this.activeModal.close(this.fromParent.enter);
        }

    }

    continueAnyway() {
        this.activeModal.close(this.fromParent.enter);
    }

    fix() {
        this.activeModal.dismiss();
    }


}
